// src/reducers/videoSubmissionReducer.js
import {
  REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL,
  REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_SUCCESS,
  REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_FAILURE,
  UPLOAD_VIDEO_FILE,
  UPLOAD_VIDEO_FILE_SUCCESS,
  UPLOAD_VIDEO_FILE_FAILURE,
  UPLOAD_VIDEO_FILE_PROGRESS,
  RESET_VIDEO_SUBMISSION_STATE,
} from "../actions/videoSubmissionActions";

const initialState = {
  presignedUrl: null,
  uploadStatus: "idle", // idle, requesting, uploading, success, error
  uploadProgress: 0,
  error: null,
};

const videoSubmissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL:
      return {
        ...state,
        uploadStatus: "requesting",
        error: null,
      };

    case REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_SUCCESS:
      return {
        ...state,
        presignedUrl: action.payload,
        uploadStatus: "ready",
        error: null,
      };

    case REQUEST_VIDEO_SUBMISSION_PRESIGNED_URL_FAILURE:
      return {
        ...state,
        uploadStatus: "error",
        error: action.payload,
        presignedUrl: null,
      };

    case UPLOAD_VIDEO_FILE:
      return {
        ...state,
        uploadStatus: "uploading",
        uploadProgress: 0,
        error: null,
      };

    case UPLOAD_VIDEO_FILE_PROGRESS:
      return {
        ...state,
        uploadProgress: action.payload,
      };

    case UPLOAD_VIDEO_FILE_SUCCESS:
      return {
        ...state,
        uploadStatus: "success",
        uploadProgress: 100,
        error: null,
      };

    case UPLOAD_VIDEO_FILE_FAILURE:
      return {
        ...state,
        uploadStatus: "error",
        error: action.payload,
        uploadProgress: 0,
      };

    case RESET_VIDEO_SUBMISSION_STATE:
      return initialState;

    default:
      return state;
  }
};

export default videoSubmissionReducer;
